/* eslint-disable @typescript-eslint/no-unused-vars */
/* Autogenerated, do not modify! */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import SvgIcon from '@move-ui/svg-icon';
export const FuelConsHighwayIcon = (_a) => {
    var { fillColor = 'currentColor', strokeColor = 'currentColor' } = _a, svg = __rest(_a, ["fillColor", "strokeColor"]);
    return (React.createElement(SvgIcon, Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24", "data-icon": true }, svg),
        React.createElement("path", { fill: fillColor, d: "M19.203 3.145a0.377 0.377 0 010.594 0C20.459 4.005 22 6.165 22 7.646c0 1.346-1.12 2.437-2.5 2.437S17 8.992 17 7.646c0-1.482 1.54-3.641 2.203-4.501zM11.25 15h1.5v-3h-1.5v3z" }),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M15.185 6.5A0.75 0.75 0 0014.478 6h-5.07a0.75 0.75 0 00-0.71 0.505l-4.657 13.5A0.75 0.75 0 004.75 21h14.5a0.75 0.75 0 000.707-1L15.185 6.5zm-2.435 13v-3h-1.5v3H5.802l4.14-12h1.308v3h1.5v-3h1.198l4.241 12h-5.44z", clipRule: "evenodd" })));
};
//# sourceMappingURL=FuelConsHighwayIcon.js.map